var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"t-lk-title-link t-lk-container-mobile"},[_c('h1',{staticClass:"t-lk-title t-lk-title-link__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('btn-green-cmp',{attrs:{"link":_vm.link,"name":_vm.name}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/templates/components/lk/lk-title-link/lk-title-link.vue?vue&type=template&id=5f216266&
// module id = 1322
// module chunks = 0